<section
  [style.background-color]="isEnabled ? enabledColor : disabledColor"
  [class.disabled]="disabled"
  (click)="toggle()"
>
  <div
    [style.left]="isEnabled ? 'auto' : '4px'"
    [style.right]="isEnabled ? '4px' : 'auto'"
    class="toggle background-background"
  ></div>
</section>
